import React, { FC } from 'react';
import { StructuredProject } from '@mb/lib';
import { ProductSearchMaterial } from '../../../types';
import { ModalSidebar } from '../ModalSidebar';
import { ProductGrid } from '../ProductGrid';
import { ProductGridControls } from '../ProductGridControls';
import { CardAttributesType, CategoryType } from '../types';

import styles from './contentBlockDisplay.module.scss';
import { ProjectAnalyticsProps } from '../../../components/Cards/ResultCard/types';

interface ContentBlockModalDisplayProps {
  id: string;
  indexLocation: number;
  isLoading: boolean;
  cardAttributes: CardAttributesType;
  results: ProductSearchMaterial[];
  categories: CategoryType[];
  activeFilters: string[];
  isMobile?: boolean;
  onCategoryClick: (filterKey: string) => void;
  handleAddToBag: () => void;
  onSelectAll: () => void;
  handleAddToBoard: () => void;
  onHandleCancel: () => void;
  handleProductSelect: (product: ProductSearchMaterial) => void;
  selectedProducts?: ProductSearchMaterial[];
  isBagLoading: boolean;
  handleProjectClick?: (
    projectid?: number,
    options?: { analyticsEventLocation?: string | undefined },
  ) => void;
  onProjectSelect?: (projectId: number) => void;
  selectedProject: StructuredProject;
  onCreateProjectClick?: (props: ProjectAnalyticsProps) => void;
}

export const ContentBlockModalDisplay: FC<ContentBlockModalDisplayProps> = ({
  id,
  indexLocation,
  isLoading,
  cardAttributes,
  results,
  categories,
  activeFilters,
  isMobile = false,
  onCategoryClick,
  handleAddToBag,
  onSelectAll,
  handleAddToBoard,
  onHandleCancel,
  handleProductSelect,
  selectedProducts = [],
  isBagLoading = false,
  handleProjectClick,
  onProjectSelect,
  selectedProject,
  onCreateProjectClick,
}) => {
  const isSelectAllDisabled = selectedProducts.length > 75;
  const isProductInSelected = selectedProducts.some(
    (item: ProductSearchMaterial) => item?.isProduct,
  );
  const isDigitalInSelected = selectedProducts.find(
    (item: ProductSearchMaterial) => item?.isDigital,
  );
  const isAddToBagDisabled =
    isBagLoading ||
    isProductInSelected ||
    Boolean(isDigitalInSelected) ||
    selectedProducts?.length === 0;

  return (
    <>
      {cardAttributes && !isLoading ? (
        <div className={styles.modalWrapper}>
          <div className={styles.modalSidebarWrapper}>
            <ModalSidebar
              id={id}
              index={indexLocation}
              cardAttributes={cardAttributes}
              categories={categories}
              activeFilters={activeFilters}
              onCategoryClick={onCategoryClick}
            />
          </div>
          <div className={styles.contentBlockResults}>
            <div className={styles.contentBlockControlsWrapper}>
              {selectedProducts.length > 0 ? (
                <ProductGridControls
                  currentView="grid"
                  handleAddToBag={handleAddToBag}
                  handleAddToBoard={handleAddToBoard}
                  handleCancel={onHandleCancel}
                  handleOnlySamplesSwitch={() => {}}
                  handleOpenDeleteConfirmationModal={() => {}}
                  handleSelectAll={onSelectAll}
                  handleShareExportTo={() => {}}
                  isAddToBagDisabled={isAddToBagDisabled}
                  isSelectAllDisabled={isSelectAllDisabled}
                  isMobileDevice={isMobile}
                  shouldShowDeleteButton={false}
                  numberOfSelectedItems={selectedProducts.length}
                  addToBagTooltip={
                    isAddToBagDisabled
                      ? 'Not available for products'
                      : undefined
                  }
                />
              ) : null}
            </div>

            <ProductGrid
              products={results}
              blockId={id}
              indexLocation={indexLocation}
              handleProductSelect={handleProductSelect}
              handleProjectClick={handleProjectClick}
              selectedProducts={selectedProducts}
              onProjectSelect={onProjectSelect}
              selectedProject={selectedProject}
              onCreateProjectClick={onCreateProjectClick}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};
